import React from "react";
import { useValueEffect } from "utils/DataGrid";
import { qrDesignStyleExtension } from "routes/qrcodes/qr_design/utils/QrDesignExtension";

import "./QrCodeDesignPreview.css";

export const QrCodeDesignPreview = ({ qrCode, qrDesignDetails }) => {
	const qrCodeRef = React.useRef(null);

	React.useEffect(() => {
		if (qrCodeRef.current && !!qrCode) {
			qrCode.append(qrCodeRef.current);
		}
	}, [qrCode, qrCodeRef]);

	useValueEffect(() => {
		if (qrCode) {
			qrCode.update(qrDesignDetails);
			qrCode.applyExtension((svg, options) => qrDesignStyleExtension(
				svg, options, qrDesignDetails
			));
		}
	}, qrDesignDetails);

	return (
		<div className="qr-codes-preview" data-testid="qr-codes-preview" ref={qrCodeRef} />
	);
};
